import { DropdownMenuSubTrigger as SDropdownMenuSubTrigger } from '@/components/ui/dropdown-menu';
import { ReactNode } from 'react';

export function DropdownMenuSubTrigger({
  children,
  count,
}: {
  children: ReactNode;
  count: number;
}) {
  return (
    <SDropdownMenuSubTrigger className="w-full">
      <div className="w-full flex justify-between items-center">
        <div className="flex gap-2 items-center">{children}</div>
        {count > 0 && (
          <span className="bg-primary-red-400 rounded-full size-4 text-neutrals-100 flex justify-center items-center text-xs">
            {count}
          </span>
        )}
      </div>
    </SDropdownMenuSubTrigger>
  );
}
